import { ComponentStoreV2Factory } from '../../modules/shared/store/common/component-store-v2.factory';
import { ifArrayHasAny } from '@libs/types/src/utils/array.utils';
import { DefaultCategoryTypeEnum } from '@libs/types/src/file-manager/types/default-category.type';
import { OrganizationSettingTypeEnum } from '@libs/types/src/organization/enum/organization-setting-type.enum';

// Duplicated `allowedWorkTypesByExpertise`
export function getAllowedFileCategories(
    store: ComponentStoreV2Factory,
    options: {
        serviceId?: number,
    } = {},
): string[] {
    const res = [];

    if (store.globalGlobalStore.organizationStore.isSettingActive(OrganizationSettingTypeEnum.HEALTHCARE_SOCIAL_SETTINGS)() && store.isAllowed('service.read')()) {
        const expertises = store.globalGlobalStore.organizationStore.services()
            .filter((it) => !options.serviceId || options.serviceId == it.id)
            .map((it) => Number(it.expertise?.code || 0))
        ;

        res.push(
            ifArrayHasAny(DefaultCategoryTypeEnum.VOUCHER, expertises, 902, 913, 925),
            DefaultCategoryTypeEnum.FORMS,
            ifArrayHasAny(DefaultCategoryTypeEnum.ANAMNESIS, expertises, 926, 720),
            ifArrayHasAny(DefaultCategoryTypeEnum.CARE_PLAN, expertises, 926, 720),
            DefaultCategoryTypeEnum.MEDICATION,
            ifArrayHasAny(DefaultCategoryTypeEnum.E_PRESCRIPTION, expertises, 926, 720),
            ifArrayHasAny(DefaultCategoryTypeEnum.SICK_NOTES, expertises, 926, 720),
            ifArrayHasAny(DefaultCategoryTypeEnum.EPICRISIS, expertises, 926, 720),
            DefaultCategoryTypeEnum.SERVICE_RECORDS,
            ifArrayHasAny(DefaultCategoryTypeEnum.DOCTOR_RECORDS, expertises, 926, 720),
            ifArrayHasAny(DefaultCategoryTypeEnum.MEDICAL_REPORT, expertises, 720),
            ifArrayHasAny(DefaultCategoryTypeEnum.SPECIALIST_RECORDS, expertises, 926),
            DefaultCategoryTypeEnum.SERVICE_CATEGORIES,
            DefaultCategoryTypeEnum.CHATS_AND_VIDEO_CALLS,
            DefaultCategoryTypeEnum.FORMS,
            DefaultCategoryTypeEnum.BILLING,
            ifArrayHasAny(DefaultCategoryTypeEnum.VISITS, expertises, 902, 925, 926),
            ifArrayHasAny(DefaultCategoryTypeEnum.UNREALIZED_VISIT, expertises, 902, 925, 926),
            ifArrayHasAny(DefaultCategoryTypeEnum.EXTRAMURAL_CARE, expertises, 926),
            ifArrayHasAny(DefaultCategoryTypeEnum.RESIDUARY_CARE, expertises, 926),
            ifArrayHasAny(DefaultCategoryTypeEnum.INTERVENTION, expertises, 913),
        );
    }
    res.push(
        DefaultCategoryTypeEnum.DEFAULT,
    );

    return res.filter((it) => it);
}
